import Base from './Base';
import { Pillar } from '@interfaces/pillar';
import { Section } from '@components/FormFlow/FormflowComponent';

export class BaseProcess extends Base {
    readonly pillar: Pillar;
    name: string;
    help?: string;
    readTarget: boolean;
    sections: Section[];
    version: number;
    oldVersions?: string[];
    obsolete?: boolean;
    units: string[];
    pathKeys: string[];
    langs?: ProcessLangs[]

    constructor(pillar: Pillar) {
        super();

        this.pillar = pillar;
    }
}

export interface ProcessLangs {
    id: string;
    url: string;
}

